import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import type {PlatformPostPreviewProps} from '@Components/social-media/components/social-post-content-multiposting/social-post-content-multiposting.types';
import {MIN_PAGES_FOR_MULTI_PAGE_LAYOUT, PreviewMediaFit, PreviewMediaLayout} from '@Components/social-media/components/social-post-content-multiposting/social-post-content-media-wrapper/social-post-content-media-wrapper.types';
import {PINTEREST_ENGAGEMENT_ICON_NAMES, PINTEREST_SAVE_ICON_NAME} from './pinterest-post-preview.types';
import styles from './pinterest-post-preview.module.scss';

export function PinterestPostPreview({numberOfPages, renderMedia}: PlatformPostPreviewProps): ReactElement {
  const getMediaLayout = (): PreviewMediaLayout => {
    return numberOfPages >= MIN_PAGES_FOR_MULTI_PAGE_LAYOUT ? PreviewMediaLayout.CAROUSEL : PreviewMediaLayout.SINGLE;
  };

  const getEngagementIcons = (): ReactElement => {
    return (
      <div className={styles.pinterestEngagementIcons}>
        {PINTEREST_ENGAGEMENT_ICON_NAMES.map((iconName) => {
          return <Icon ariaHidden className={styles.pinterestActionIcon} icon={iconName} key={iconName} size={IconSize.SIZE_ICON_16} />;
        })}
      </div>
    );
  };

  return (
    <div className={styles.pinterestPost}>
      {renderMedia({layout: getMediaLayout(), fit: PreviewMediaFit.COVER, frameClassName: styles.pinterestMediaFrame})}
      <div className={styles.pinterestActionBar}>
        {getEngagementIcons()}
        <Icon ariaHidden className={styles.pinterestActionIcon} icon={PINTEREST_SAVE_ICON_NAME} size={IconSize.SIZE_ICON_16} />
      </div>
    </div>
  );
}
